import { MerchantListFiltersState } from './merchantListFilters.slice';

type StateWithMerchantListFilters = { merchantListFilters: MerchantListFiltersState };

export const selectMerchantListFilters = (state: StateWithMerchantListFilters) => state.merchantListFilters.filters;

export const selectMerchantListTotal = (state: StateWithMerchantListFilters) => state.merchantListFilters.total;
